import _memoize from 'lodash/memoize';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY, SECONDARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { identity } from '../../../../utils/sizes';
import { makeDefaultStylingContext } from '../../../../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const LINE_HEIGHT = {
  [HD]: 4,
  [FULL_HD]: 4,
};

export const LABEL_MARGIN_BOTTOM = {
  [HD]: 3,
  [FULL_HD]: 4,
};

export const colors = {
  text: makeThemeColor(PRIMARY),
  line: makeThemeColor(SECONDARY),
};

export const DEFAULT_ALPHA = 0.6;

export const SELECTED_ALPHA = 1;

export const getLabelFont = screenSize => getFont(FONT.OTTAWA_2, screenSize);

export const getHeight = screenSize =>
  getLabelFont(screenSize).lineHeight + LABEL_MARGIN_BOTTOM[screenSize] + LINE_HEIGHT[screenSize];

export const getInitialStyle = _memoize(({ screenSize, colorMode } = defaultContext) => ({
  h: getHeight(screenSize),
  Label: {
    alpha: DEFAULT_ALPHA,
    color: colors.text[colorMode],
    text: {
      ...getLabelFont(screenSize),
      verticalAlign: 'middle',
    },
  },
  Line: {
    mountY: 1,
    h: LINE_HEIGHT[screenSize],
    w: identity,
    y: height => height - LINE_HEIGHT[screenSize],
    color: colors.line[colorMode],
    scaleX: 0,
  },
}));

export const getFocusedStyle = isSelected => ({
  Label: {
    smooth: {
      alpha: SELECTED_ALPHA,
    },
  },
  Line: {
    smooth: {
      alpha: isSelected ? SELECTED_ALPHA : DEFAULT_ALPHA,
      scaleX: isSelected ? 1 : 0,
    },
  },
});

export const getUnFocusedStyle = isSelected => ({
  Label: {
    smooth: {
      alpha: DEFAULT_ALPHA,
    },
  },
  Line: {
    smooth: {
      alpha: DEFAULT_ALPHA,
      scaleX: isSelected ? 1 : 0,
    },
  },
});
